'use strict';
module.exports = require('./DataTable.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/datatable/index.js
// module id = 6
// module chunks = 1